//-----------------------------------
// collection.js
// => theme/sections/collection.liquid
// => theme/sections/filters.liquid
//-----------------------------------
import $ from 'jquery';
import Vue from 'vue';
import { quickAdd } from '../snippets/quickAddNew';

export const collection = {
  init(){
    collection.initalizeVue()
    
  },
  initalizeVue(){
    const collectionVue = new Vue({
      el: '#collection-wrap',
      delimiters: ['#{', '}'],
      data:{
        filterParams: {
          "size": [],
          "tag": [],
          "product_type": [],
          "feature": [],
          "fabric": [],
          "color": [],
          "breast-shape": []
        },
        windowHeight: 0,
        filterSchema: {},
        asyncFilterFailure: false
      },
      computed:{
        filterScrollHeight: function(){
          /*
          Returns max-height for scrollable filter area in px
          */
          const offset = 140
          if(window.innerWidth < 1024){
            return `${this.windowHeight - offset}px`
          } else {
            return `${this.windowHeight - 300}px`
          }
          
        },
        filteredUrl: function(){
          let url = window.Shopify.routes.root + 'collections/' + window.collection.collection_handle + '?'
          // let tags = 'filter.p.tag='
          // let sizes = 'filter.v.option.size='
          // // let productTypes = 'filter.p.product_type='
          // let productTypes = 'filter.p.product_type='
          // let features = "filter.p.m.custom.feature="
          // let fabric = "filter.p.m.custom.fabric="
          // let color = "filter.p.m.custom.color="
          let tags = ''
          let sizes = ''

          let productTypes = ''
          let features =''
          let fabric = ''
          let color = ''
          let breast_shape = '';

          // size filters
          if(this.filterParams['size'].length){
            //build cup and bands together for url
            const cups = this.filterParams["size"].filter(param => param.includes('cup'))
            const bands = this.filterParams["size"].filter(param => param.includes('band'))
            const otherSizes = this.filterParams["size"].filter(param => (!param.includes('cup') && !param.includes('band')))

            if(cups.length && bands.length){ //build cup and bands together
              bands.forEach(band => {
                cups.forEach(cup => {
                  sizes += 'filter.v.option.size=' + band.replace('band-','') + cup.replace('cup-','') + '&'
                })
              })
            } else if(cups.length){ //build cups with every band from schema
              this.filterSchema.band_sizes.forEach(band => {
                cups.forEach(cup => {
                  sizes += 'filter.v.option.size=' + band + cup.replace('cup-', '') + '&'
                })
              })
            } else if(bands.length){ //build bands with every cup from schema
              this.filterSchema.cup_sizes.forEach(cup => {
                bands.forEach(band => {
                  sizes += 'filter.v.option.size=' + band.replace('band-','') + cup + '&'
                })
              })
            }
            otherSizes.forEach(param => {
              sizes += 'filter.v.option.size=' + param +  '&'
            })
            url = url + sizes
            // url += sizes
          }
          // tag filters
          if(this.filterParams['tag'].length){
            this.filterParams['tag'].forEach((tag, index) => {
              // index === this.filterParams['tag'].length -1 ? tags += tag : tags += tag + ','
              tags += 'filter.p.tag=' + tag + '&'
            })
            url += tags
          }
          //product type filters
          if(this.filterParams["product_type"].length){
            console.log("filter params types")
            console.log(this.filterParams["product_type"])
            this.filterParams["product_type"].forEach((types, index) => {
              types = types.split(',')
              types.forEach(type => {
                productTypes += 'filter.p.product_type=' + type + '&' + 'filter.p.product_type=' + `sale-${type}` + '&' + 'filter.p.product_type=' + `discount-${type}` + '&'
              })
            })
            url += productTypes
          }

          if(this.filterParams["feature"].length){
            this.filterParams["feature"].forEach(feature => {
              features += 'filter.p.m.custom.feature=' + feature + '&'
            })
            url += features
          }

          if(this.filterParams["fabric"].length){
            this.filterParams["fabric"].forEach(f => {
              fabric += 'filter.p.m.custom.fabric=' + f + '&'
            })
            url += fabric
          }

          if(this.filterParams["color"].length){
            this.filterParams["color"].forEach(c => {
              color += 'filter.p.m.custom.color_family=' + c + '&'
            })
            url += color
          }
          //product type filters
          if(this.filterParams["breast-shape"].length){
            this.filterParams["breast-shape"].forEach(c => {
              breast_shape += 'filter.p.m.custom.breast_shape=' + c + '&'
            })
            url += breast_shape
          }

          console.log(url.slice(0, -1))
          return url.slice(0, -1)
        },
        filterCount: function(){
          let bundleSet = false
          let count = 0 
          let arrs = Object.keys(this.filterParams)
          arrs.forEach(key => {
            console.log("FILTER COUNT")
            this.filterParams[key].forEach(item => {
              if(item.includes('pack-')){
                if(!bundleSet){
                  count ++
                  bundleSet = true
                }
              } else{
                count ++
              }
            })
          })
          return count
        }
      },
      watch: {

      },
      methods: {
        eventListeners: function() {
          //marketing tile height
          $(document).ready(function(){
            $('.mt').each(function(){
              const height = $('.Coll-grid').find('.ProductCard-image-wrap').height()
              if(height > 200){
                $(this).css("height", height)
              }
            })
          })  
          
          //Filter buttons sticky top
          const filterBtns = document.getElementById('filter-btns-header')
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if(entry.isIntersecting){
                document.getElementById('coll-sticky-top').style.display = "none"
              } else {
                document.getElementById('coll-sticky-top').style.display = "block"
              }
            })
          })
          onscroll = () => { 
            observer.observe(filterBtns)
            //filter scroll desktop
            const position = $(document).height() - $(window).scrollTop() - $(window).height()
            if(position < 400){
              let distance = 400 - position
              document.querySelector('.Filters-fixed').style.bottom = `${distance + 400}px`
            } else if(document.querySelector('.Filters-fixed').style.bottom !== "auto"){
              document.querySelector('.Filters-fixed').style.bottom = "auto"
            }
            // document.querySelector('.Filters-fixed')
            // console.log($(document).height() - $(window).scrollTop() - $(window).height())
          }

          //Filter options toggle - jquery still rocks
          $('.Filters-row-title').each(function(){
            $(this).click(function(){
              console.log($(this))
            //collapse each other one.. desktop only??
            $(this).parent().siblings('.Filters-row').children('.Filters-row-title').each(function(){
              if($(this).is(':visible') && window.innerWidth > 1024){
                $(this).siblings('.Filters-values').slideUp('fast')
                $(this).children('.Filters-row-icon').animate({'opacity': 0}, 200, function(){
                  $(this).html('+').animate({'opacity': 1}, 200);    
                });
              }
            })
              if($(this).siblings('.Filters-values').is(':visible')){ 
                $(this).siblings('.Filters-values').slideUp('fast')
                $(this).children('.Filters-row-icon').animate({'opacity': 0}, 200, function(){
                  $(this).html('+').animate({'opacity': 1}, 200);    
                });

              } else {
                $(this).siblings('.Filters-values').slideDown('fast')
                $(this).children('.Filters-row-icon').animate({'opacity': 0}, 200, function(){
                  $(this).html('-').animate({'opacity': 1}, 200);    
                });
              } 
            })
          })

          //resize filter overlay mobile
          window.addEventListener("resize", this.resize);

          //toggle swatch expand
          $('.js-swatch-expand').each(function(){
            $(this).click(function(){
              $(this).addClass('swatchItem--hidden')
              $(this).siblings().each(function(){
                $(this).removeClass('swatchItem--hidden')
              })
              $(this).children('button').attr('aria-expanded', 'true');
            })
          })

          //category scroll promo collections only
          if(window.collection.scroll_top_enabled){
            const offset = window.innerWidth >= 1024 ? 250 : 200
            $('.promo-category-item').each(function(){
              $(this).on("click", function(){
                const scrollTarget = $(this).attr('data-handle').replace('item', 'wrap')
                const scrollTop = $(`[data-handle=${scrollTarget}]`).offset().top
                $('html, body').animate({
                  scrollTop: scrollTop - offset
                }, 'fast'); 
              })
            })
          }
        },
        toggleFilters: function() {
          document.getElementById('filters-wrap').classList.toggle('is-open')
          document.body.classList.toggle('noscroll-mobile')
        },
        handleSortByChange: function(e){
          Shopify.queryParams = {};

          // Preserve existing query parameters
          if (location.search.length) {

            const params = location.search.substr(1).split('&');
            console.log("Sort by change")
            console.log(params)
        
            for (var i = 0; i < params.length; i++) {
              const keyValue = params[i].split('=');
              
              if (keyValue.length && keyValue[0] !== 'page') {
                Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
              }
            }
          }
          const value = e.target.value
          Shopify.queryParams.sort_by = value;
          location.search = new URLSearchParams(Shopify.queryParams)
            .toString()
            .replaceAll('%2C',',');
        },
        handleFilterOptionClick: function(e){

          // select items
          const param = e.target.attributes["data-value"] ? e.target.attributes["data-value"].value.replace('%20', ' ') : null
          const filterType = e.target.attributes["data-filter-type"].value

          if(this.filterParams[filterType].includes(param)) {
            this.filterParams[filterType].splice(this.filterParams[filterType].indexOf(param), 1)
          } else if(param.includes('pack-') && this.filterParams[filterType].find(param => param.includes('pack-'))){
            this.filterParams[filterType] = this.filterParams[filterType].filter(type => !type.includes('pack-'))
            
          } else{
            param && this.filterParams[filterType].push(param)
          }
          //for non checkbox options only 
       
            e.target.classList.toggle('selected')

            //toggle active swatch border for colors
            const swatch = e.target.querySelector('.Filters-swatch-border')
            swatch && swatch.classList.toggle('selected')
          

          //Row counts
          const rowCountElem = e.target
              .closest('.Filters-row')
              .querySelector('.Filters-row-count')

          const rowCountText = rowCountElem
                .innerHTML
                .replace('(', '')
                .replace(')', '')

          let count = parseInt(rowCountText)
          count = count ? count : 0

          if((!e.target.classList.contains('selected') && !e.target.type === true) || (e.target.type == 'checkbox' && !e.target.checked)){
            count === 1 ? rowCountElem.innerHTML = '' : rowCountElem.innerHTML = `(${count - 1})`            
          } else {
            rowCountElem.innerHTML = `(${count + 1})`
          }


        },
        resize: function(){
          //filter overlay
          this.windowHeight = window.innerHeight
          // if(window.innerWidth < 1024){
          document.getElementById('filters-wrap').style.height = `${this.windowHeight}px `
          // }
          //marketing tiles dynamic height
          $('.mt').each(function(){
            const height = $('.Coll-grid').find('.ProductCard-image-wrap').height()
            if(height > 200){
              $(this).css("height", height)
            }
          })
 

        },
        setSelectedFilters: function(){
          //sets the selected filters if any are present in the url
          //https://localhost:3000/collections/bras?filter.v.option.size=36C,4&filter.p.tag=color-jet-black,color-toasted-almond
          if(window.location.href.includes("filter")){
            let selectedFilters = []
            console.log("Set selected debug")
            const filters = window.location.href
              .split('?')[1]
              .split('&')
            
            filters.forEach(filter => {
              const values = filter
                .split("=")[1]
                .split(',')
              selectedFilters = [...selectedFilters, ...values]
            })

            if(this.filterSchema.band_sizes){ 
              const cupsAndBands = selectedFilters.filter(filter=> this.filterSchema.band_sizes.some(size => filter.includes(size)))
              console.log("cup and bands")
              console.log(cupsAndBands)
              cupsAndBands.forEach(val => {
                const arr = val.match(/([0-9]+)([^0-9]+)/).splice(1)
                const band = arr[0]
                const cup = arr[1]
                selectedFilters.slice(selectedFilters.indexOf(val), 1)
                !selectedFilters.includes(band) && selectedFilters.push('band-' + band)
                !selectedFilters.includes(cup) && selectedFilters.push('cup-' + cup)
              })
            }

            console.log(selectedFilters)
            // let bundlesSet = false
            selectedFilters.forEach(filter => {
              console.log(filter.replaceAll('%20', ' '))

              let elems = document.querySelectorAll(`[data-value="${filter.replaceAll('%20', ' ')}"]`)
              console.log("ELEMS")
              console.log(elems)

              if(filter.includes('pack-')){
                elems = document.querySelectorAll(`[data-value*="${filter}"`) 
                // bundlesSet = true
              } 

              let countSet = false
              elems.length > 0 && elems.forEach(elem => {
                console.log(elem)
                const filterRowCount = elem
                  .closest('.Filters-row')
                  .querySelector('.Filters-row-count')

                const filterRowCountText = filterRowCount
                  .innerHTML
                  .replace('(', '')
                  .replace(')', '')

                if(!elem.classList.contains('selected')){
                  const count = parseInt(filterRowCountText)
                  if(!count){
                    filterRowCount.innerHTML = "(1)"
                    countSet = true
                  } else if(countSet == false){
                    filterRowCount.innerHTML = `(${count + 1})`
                    countSet = true
                  } 
                }

                const filterType = elem.getAttribute('data-filter-type')
                !this.filterParams[filterType].includes(filter) && this.filterParams[filterType].push(filter.replaceAll('%20', ' '))
                elem.classList.add('selected')
                if(elem.type === "checkbox"){
                  elem.setAttribute('checked', 'checked');
                }
              })
            })
          }
          if(window.collection.is_promo_template && this.filterCount > 0){
            this.filterPromoSections()
          }
        },
        filterPromoSections: function(){
          console.log("FILTER PROMO COLLECTIONS")
          // can also get an accurate product count in here somewhere?????
          //get current products
          let productData = {}
          const productSections = document.querySelectorAll('.Coll-grid')
          productSections.forEach(section => {
            const collectionHandle = section.getAttribute('data-handle')
            const handleList =  [...section.querySelectorAll('.ProductCard')].map(product => product.getAttribute('data-handle'))
            productData[collectionHandle] = handleList
          })
          //fetch sorted products
          this.swapProducts(productData)
            .then(()=> {
              quickAdd.init()
              this.resize()
            })
            .catch(err => {
              console.log(err)
              this.asyncFilterFailure = true
            })
        },
        swapProducts: async function(productData){
          for(const handle in productData){
            try{
              //replace the promo collection filtered url with the respective collection
              const url = this.filteredUrl.replace(window.collection.collection_handle, handle)
              const response = await fetch(url)
              const data = await response.text()
              const parser = new DOMParser()
              const newDoc = parser.parseFromString(data, "text/html");
              const newGrid = newDoc 
                .querySelector('.Coll-grid')

              const productLimit = document
                .querySelector(`[data-handle="${handle}"]`)
                .getAttribute('data-limit')

              let productCards = newDoc.querySelectorAll('.ProductCard')

              if(productCards.length > 0){
                productCards.forEach((productCard, index) => {
                  if(index >= productLimit){
                    productCard.remove()
                  } else {
                    const select = productCard.querySelector('.ProductCard-actions')
                    select.removeAttribute('v-pre')
                    const img = productCard.querySelector('.ProductCard-image')
                    img.removeAttribute('v-cloak')
                  }
                })

                const newProducts = newGrid && newGrid.innerHTML

                document
                  .querySelector(`[data-handle="${handle}"]`) 
                  .innerHTML = newProducts   

              } else {
                document
                  .querySelector(`[data-handle="${handle}-wrap"]`)
                  .remove()
              }

            } catch(err) {
              console.log(err)
            }
          }
          //async filter fail state
          const sections =  document.querySelectorAll('.Coll-promo-section')
          if(sections.length <= 0){
            this.asyncFilterFailure = true
          }
        },
        setSelectedSort: function(){
          $('.sort-by').each(function(){
            $(this).children().each(function(){
              if(window.location.href.includes($(this)[0].value)){
                $(this).attr('selected', 'selected')
              }
            })
          })
        },
        gaBreadcrumb: function(e){
          gtag('event', 'breadcrumb_click', {
            'link': e.target.pathname,
            'current_page' : window.location.pathname
          })
        },
        gaFilters: function(e){
          gtag('event', 'plp_filter', {
            'size': this.filterParams["size"],
            'tag' : this.filterParams["tag"],
            "product_type": this.filterParams["product_type"],
            "features": this.filterParams["features"],
            "fabric": this.filterParams["fabric"],
            "color": this.filterParams["color"]
          })
        }
      },
      created(){
        this.filterSchema = window.collection.filter_schema
        this.setSelectedSort()
        this.setSelectedFilters()
      }, 
      mounted(){
        this.eventListeners()
        this.resize()
        if(!window.collection.is_promo_template || this.filterCount == 0){
          quickAdd.init()
        }
      }
    })
  }
}

